import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=3c4508d7"
import script from "./roleForm.vue?vue&type=script&lang=js"
export * from "./roleForm.vue?vue&type=script&lang=js"
import style0 from "./roleForm.vue?vue&type=style&index=0&id=3c4508d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports